import React from "react";
import { get } from "lodash";
import isValidDomain from "is-valid-domain";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import AddRemoveInputList from "@irati/ui/src/AddRemoveInputList";
import { ValidationButton } from "@irati/ui/src/FormItem";
import Validation from "@irati/utils/validation";
import Loading from "@irati/ui/src/Loading";
import authentication from "@irati/auth";
import { Para } from "@irati/ui/src/Labels";
import SignUpOption from "./SignUpOption";
import { EMAIL, EMAIL_VALIDATION_DESCRIPTION, WELCOME_MESSAGE, INVALID_DOMAINS } from "../../../../constants/selfSignUp";
import WelcomeMessage from "./WelcomeMessage";
var emailSchema = Validation.string("admin.components.emailDomain.emailSchema.validation.isRequired")
    .test({
    name: "validDomain",
    message: "admin.components.emailDomain.emailSchema.validation.message",
    test: function (value) { return isValidDomain(value); }
})
    .notOneOf(INVALID_DOMAINS, "admin.components.emailDomain.emailSchema.validation.invalidDomain");
var EmailDomain = function (_a) {
    var show = _a.show, submit = _a.submit, selfSignUp = _a.selfSignUp, onSelect = _a.onSelect, onChange = _a.onChange, onSubmit = _a.onSubmit, formatMessage = _a.formatMessage;
    var updateWelcomeMessage = function (welcomeMessage) {
        onChange("welcomeMessage", welcomeMessage);
    };
    var updateEmails = function (keys) {
        var config = get(selfSignUp, "config", {});
        config[EMAIL] = { keys: keys };
        onChange("method", EMAIL);
        onChange("config", config);
    };
    var handleSubmit = function () {
        onChange("method", EMAIL);
        onSubmit();
    };
    return (React.createElement(SignUpOption, { title: formatMessage({ id: "admin.components.emailDomain.signUpOption.title" }), description: formatMessage({ id: EMAIL_VALIDATION_DESCRIPTION }) + "\n        " + (authentication.business().subdomain + ".perkbox.com/signup"), onClick: function () { return onSelect(EMAIL); }, active: show },
        React.createElement(AddRemoveInputList, { update: updateEmails, inputs: get(selfSignUp, "config.EMAIL.keys", [null]), label: formatMessage({ id: "admin.components.emailDomain.addRemoveInputList.label" }), addButtonText: formatMessage({ id: "admin.components.emailDomain.addRemoveInputList.addButtonText" }), validation: emailSchema }),
        React.createElement(Para, null,
            React.createElement(FormattedMessage, { id: "admin.components.emailDomain.email.example" })),
        React.createElement(WelcomeMessage, { updateWelcomeMessage: updateWelcomeMessage, welcomeMessage: get(selfSignUp, "welcomeMessage", formatMessage({ id: WELCOME_MESSAGE })) }),
        React.createElement(Loading, { load: submit, useLoader: false }),
        React.createElement(ValidationButton, { primary: true, full: true, large: true, load: submit, onClick: handleSubmit },
            React.createElement(FormattedMessage, { id: "admin.components.emailDomain.validationButton.save" }))));
};
export default injectIntl(EmailDomain);
